var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.6 7.9V6c0-1.985-1.615-3.6-3.6-3.6A3.604 3.604 0 0 0 8.4 6v1.9H4.9v12.699h14.2v-12.7zM9.6 6c0-1.323 1.077-2.4 2.4-2.4s2.4 1.077 2.4 2.4v1.9H9.6zm8.3 13.4H6.1V9.1h11.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.456 16.124h-1.8v1.8h1.8zm-2.599 0h-1.8v1.8h1.8z"
  })));
};
export { SvgShoppingBag as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' d='M15.6 7.9V6c0-1.985-1.615-3.6-3.6-3.6A3.604 3.604 0 0 0 8.4 6v1.9H4.9v12.699h14.2v-12.7zM9.6 6c0-1.323 1.077-2.4 2.4-2.4s2.4 1.077 2.4 2.4v1.9H9.6zm8.3 13.4H6.1V9.1h11.8z'/%3e%3cpath fill='currentColor' d='M16.456 16.124h-1.8v1.8h1.8zm-2.599 0h-1.8v1.8h1.8z'/%3e%3c/svg%3e";